import { Routes, Route } from 'react-router-dom'
import './App.css'
import Dashboard from './page/Dashboard'
import IssueManagement from './page/IssueManagement'
import ActivityLog from './page/ActivityLog'
import IssueManagementDetails from './page/IssueManagementDetails'
import { Toaster } from 'react-hot-toast'
import Login from './page/Login'
import MainLayout from './layout/MainLayout'
import AccountActivated from './page/AccountActivated'

const App = () => {
  return (
    <div className="overflow-y-hidden">
      <Toaster position="top-center" reverseOrder={false} />
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />
        <Route path="/account-activated" element={<AccountActivated />} />
      </Routes>
      <Routes>
        <Route path="/issue-management" element={<IssueManagement />} />
        {/* Protected Routes */}
        <Route
          path="/"
          element={
            <MainLayout>
              <Dashboard />
            </MainLayout>
          }
        />
        <Route
          path="/issue-management"
          element={
            <MainLayout>
              <IssueManagement />
            </MainLayout>
          }
        />
        <Route
          path="/issue-management/:phaseId"
          element={
            <MainLayout>
              <IssueManagementDetails />
            </MainLayout>
          }
        />
        <Route
          path="/activity-log/:issueId"
          element={
            <MainLayout>
              <ActivityLog />
            </MainLayout>
          }
        />
      </Routes>
    </div>
  )
}

export default App
